module.exports = __webpack_public_path__ + "img/07.3af0b827.svg";